import { readableColor, transparentize } from 'polished';
import styled, { css, DefaultTheme, keyframes } from 'styled-components';

const mapColors = ({ theme }: { theme: DefaultTheme }) => {
  const $bg =
    theme.type === 'light' ? theme.colors.main[500] : theme.colors.black[900];

  // o contraste do spinner sai do próprio fundo, então continua legível se o
  // $bg mudar de tema (ou virar a cor do seller) sem precisar tocar aqui
  return { $bg, $fg: readableColor($bg) };
};

export const Container = styled.div.attrs(mapColors)`
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.$bg};
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.35;
  }
  50% {
    opacity: 1;
  }
`;

const ring = css`
  content: '';
  position: absolute;
  border-radius: 50%;
  border-style: solid;
  animation: ${spin} 1.1s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: ${pulse} 1.6s ease-in-out infinite;
  }
`;

export const Spinner = styled.div.attrs(mapColors)`
  position: relative;
  width: 72px;
  height: 72px;

  &::before {
    ${ring}
    inset: 0;
    border-width: 3px;
    border-color: ${(p) => transparentize(0.78, p.$fg)};
    border-top-color: ${(p) => p.$fg};
  }

  &::after {
    ${ring}
    inset: 16px;
    border-width: 2px;
    border-color: transparent;
    border-bottom-color: ${(p) => transparentize(0.4, p.$fg)};
    animation-duration: 0.8s;
    animation-direction: reverse;
  }
`;
